/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Listen_Go_WalkingInputs */

const en_onboarding_listen_go_walking = /** @type {(inputs: Onboarding_Listen_Go_WalkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`While walking or running`)
};

const es_onboarding_listen_go_walking = /** @type {(inputs: Onboarding_Listen_Go_WalkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caminando o corriendo`)
};

/**
* | output |
* | --- |
* | "While walking or running" |
*
* @param {Onboarding_Listen_Go_WalkingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_listen_go_walking = /** @type {((inputs?: Onboarding_Listen_Go_WalkingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Listen_Go_WalkingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_listen_go_walking(inputs)
	return en_onboarding_listen_go_walking(inputs)
});